const getTariffList = state => state.tariffList;

export default {
  getTariffList
};



// WEBPACK FOOTER //
// ./src/store/modules/tariff/getters.js